import { useState, useMemo } from "react";
import { movies, genres } from "@/data/movies";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { MovieGrid } from "@/components/MovieGrid";
import { Button } from "@/components/ui/button";

export default function Home() {
  const [selectedGenre, setSelectedGenre] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const filteredMovies = useMemo(() => {
    return movies.filter((movie) => {
      const matchGenre = selectedGenre === "All" || movie.genre.includes(selectedGenre);
      const matchSearch = movie.title.toLowerCase().includes(searchQuery.toLowerCase());
      return matchGenre && matchSearch;
    });
  }, [selectedGenre, searchQuery]);

  const trendingMovies = movies.slice(0, 4);
  const featuredMovie = movies[0];

  return (
    <div className="min-h-screen bg-background">
      <Header onSearch={setSearchQuery} searchValue={searchQuery} />

      <main className="max-w-7xl mx-auto px-4 md:px-6 py-8">
        <Hero movie={featuredMovie} />

        <section className="mb-12">
          <h2 className="text-xl font-bold text-foreground mb-4">Browse by Genre</h2>
          <div className="flex flex-wrap gap-3">
            {genres.map((genre) => (
              <Button
                key={genre}
                variant={selectedGenre === genre ? "default" : "outline"}
                onClick={() => setSelectedGenre(genre)}
                className="rounded-full"
              >
                {genre}
              </Button>
            ))}
          </div>
        </section>

        {searchQuery && (
          <p className="text-muted-foreground mb-6">
            Found {filteredMovies.length} movie{filteredMovies.length !== 1 ? "s" : ""} matching "{searchQuery}"
          </p>
        )}

        {filteredMovies.length > 0 ? (
          <MovieGrid title={selectedGenre === "All" ? "Trending Now" : selectedGenre} movies={filteredMovies} />
        ) : (
          <div className="flex flex-col items-center justify-center py-16">
            <p className="text-lg text-muted-foreground">No movies found</p>
            <Button variant="link" onClick={() => { setSearchQuery(""); setSelectedGenre("All"); }} className="mt-2">
              Clear filters
            </Button>
          </div>
        )}
      </main>
    </div>
  );
}
